// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__ydxgS","name":"styles_name__1f3au","phone":"styles_phone__wH-tT"};